import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ProjectPerms } from '../../../projects/fragments/generated/ProjectPerms';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type WorkspacesInfoProjectFragment = { __typename?: 'Project', adobeAssetId?: string | null, archivedAt?: string | null, deletedAt?: string | null, description?: string | null, fileCount: number, id: string, imageUrl?: string | null, isWorkfront?: boolean | null, name: string, private: boolean, isLoading?: boolean | null, storage: number, updatedAt?: string | null, workfrontProjectLink?: string | null, insertedAt: string, notificationsEnabled?: boolean | null, images: { __typename?: 'Images', image256?: string | null, image64?: string | null, original?: string | null }, workspace?: { __typename?: 'Workspace', id: string, visibleActiveProjectCount?: number | null, visibleInactiveProjectCount?: number | null } | null, permissions?: { __typename?: 'ProjectPermissions', canEditTranscription: boolean, canCopyComment: boolean, canDownloadComment: boolean, canDelete: boolean, canUpdate: boolean, canUpdateAsset: boolean, canCreateAsset: boolean, canShare: boolean, canCreateComment: boolean, canUpdateCommentStatus: boolean, canReactToComment: boolean, canViewComment: boolean, canCreateCommentAttachment: boolean, canDeleteComment: boolean, canDownloadCommentAttachment: boolean, canCopyAsset: boolean, canDeleteAsset: boolean, canMoveAsset: boolean, canDownloadAsset: boolean, canDeleteCollection: boolean, canUpdateCollection: boolean, canCreateCollection: boolean, canManageAssetMetadata: boolean, canEditUserPermissions: boolean, canManageResourceControlPolicies: boolean, canViewTranscription: boolean, canCreateTranscription: boolean, canDeleteTranscription: boolean, canDownloadTranscription: boolean, canCreateCaption: boolean, canDeleteCaption: boolean, canDownloadCaption: boolean, canViewCaption: boolean, canUpdateCaption: boolean } | null };

export const WorkspacesInfoProject = /*#__PURE__*/ gql`
    fragment WorkspacesInfoProject on Project {
  adobeAssetId
  archivedAt
  deletedAt
  description
  fileCount
  id
  images {
    image256
    image64
    original
  }
  imageUrl
  isWorkfront
  name
  private
  isLoading @client
  storage
  updatedAt
  workfrontProjectLink
  workspace {
    id
    visibleActiveProjectCount: projectCount(filter: {status: ACTIVE})
    visibleInactiveProjectCount: projectCount(filter: {status: INACTIVE})
  }
  insertedAt
  notificationsEnabled
  ...ProjectPerms
}
    ${ProjectPerms}` as unknown as DocumentNode<WorkspacesInfoProjectFragment, unknown>;

        

        
export const useWorkspacesInfoProjectFragment = (
  input: string | Omit<UseFragmentOptions<WorkspacesInfoProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<WorkspacesInfoProjectFragment>({
    fragment: WorkspacesInfoProject,
    fragmentName: 'WorkspacesInfoProject',
    ...options,
  });
};
  
        